import { components } from "@/api-schema";
import { UserStatus } from "@/api-schema-enums";
import { automaticCellRenderer } from "@/components/data-table/_helpers/cell-renderer";
import { ImplementedDisplayColumnDef } from "@/components/data-table/types";
import { UserAvatar } from "@/components/user-avatar/user-avatar";
import i18next from "i18next";

type UserWithMembershipTableType = components["schemas"]["UserWithMembershipResponseDto"];

export const userWithMembershipTableDefaultColumns = {
  columnAvatar: {
    id: "avatar",
    size: 50,
    enableSorting: false,
    cell: ({ row }) => {
      const isDisabled = isUserDisabled(row.original);
      return (
        <div className="relative">
          <div className={getDisabledAvatarClassName(isDisabled)}>
            <UserAvatar userAzureObjectUuid={row.original.azureObjectUuid} name={row.getValue("name")} />
          </div>
        </div>
      );
    },
  } as ImplementedDisplayColumnDef<UserWithMembershipTableType>,

  columnName: {
    id: "name",
    size: 1000,
    enableSorting: false,
    header: () => i18next.t("common:Name"),
    accessorFn: (row) => `${row.lastName || ""}, ${row.firstName || ""}`.trim().replace(/^,\s*/, ""),
    cell: (row) => automaticCellRenderer(row.getValue()),
  } as ImplementedDisplayColumnDef<UserWithMembershipTableType>,
};

const isUserDisabled = (user: UserWithMembershipTableType): boolean => user.status === UserStatus.Disabled;

const getDisabledAvatarClassName = (isDisabled: boolean): string => (isDisabled ? "opacity-40 grayscale" : "");
